import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui/dist';

export const CHANGE_PASSWORD = gql`
  mutation ($currentPassword: String, $newPassword: String!) {
    changePassword(payload: { currentPassword: $currentPassword, newPassword: $newPassword }) {
      _id
    }
  }
`;

export const useChangePassword = () => {
  const { t } = useTranslation('settings');

  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted: () => {
      showNotification({
        type: NOTIFICATION_TYPE.success,
        isIcon: false,
        message: t('userProfileSettings.success.profileChanges.title'),
      });
    },
  });

  return changePassword;
};
